import { db, functions } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { accountAccess } from "./accountAccess";
import { accountStorage } from "./accountStorage";

// MOCK: config/plans lokal. Klien tidak boleh menjadi sumber harga; harga akun dibaca dari getPlans.
export const PLANS = {
  trialDays: 7,
  monthly: { price: 299000 },
  annual: { price: 2990000, perMonth: 249000, saving: 598000 },
};

const KEY = "axoris.mock.subscription";
const DAY = 86400000;
const iso = (offsetDays) => new Date(Date.now() + offsetDays * DAY).toISOString();

const PRESETS = {
  none: () => ({ status: "none", plan: null }),
  pilot: () => ({ status: "pilot", plan: null }),
  trialing: () => ({ status: "trialing", plan: "monthly", trialEndsAt: iso(2), methodMask: "•••• 4242" }),
  active: () => ({ status: "active", plan: "monthly", currentPeriodEnd: iso(24), methodMask: "•••• 4242" }),
  past_due: () => ({ status: "past_due", plan: "monthly", currentPeriodEnd: iso(-3), methodMask: "•••• 4242" }),
  expired: () => ({ status: "expired", plan: null, currentPeriodEnd: null }),
  canceled: () => ({ status: "canceled", plan: "monthly", currentPeriodEnd: iso(10), methodMask: "•••• 4242" }),
};

export function getSubscription() {
  const cache = accountStorage();
  const q = new URLSearchParams(window.location.search).get("sub");
  if (q && PRESETS[q]) cache.write(KEY, PRESETS[q]());
  return cache.read(KEY, PRESETS.none());
}

export const setSubscription = (sub) => accountStorage().write(KEY, sub);

export const endDate = (s) => s.trialEndsAt ?? s.currentPeriodEnd ?? null;

export function isEntitled(s = getSubscription()) {
  return accountAccess(s).allowed;
}

/**
 * Membaca paket harga langsung dari callable getPlans di server (config/plans).
 * Menghindari kalkulasi atau hardcode harga di klien.
 */
export async function fetchPlans() {
  try {
    const fn = httpsCallable(functions, "getPlans");
    const res = await fn({});
    if (res.data?.ok && res.data?.plans) {
      return res.data;
    }
  } catch (err) {
    // offline or fallback
  }
  return null;
}

// startTrial dan cancelSubscription tidak menulis status langganan palsu.
// Batal sungguhan menunggu integrasi gateway.
export function startTrial() {
  return null;
}

export function cancelSubscription() {
  return getSubscription();
}

export const rp = (n) => typeof n === "number" ? `Rp${n.toLocaleString("id-ID")}` : "";

export const firstBillingDate = () => new Date(Date.now() + 7 * DAY);

export async function startCheckout(plan = "monthly") {
  try {
    const fn = httpsCallable(functions, "startCheckout");
    const res = await fn({
      plan,
      returnUrl: `${window.location.origin}/langganan/hasil`,
    });
    return res.data;
  } catch (err) {
    return null;
  }
}

export const fmtDate = (lang, d) =>
  new Intl.DateTimeFormat(lang === "en" ? "en-GB" : "id-ID", { day: "numeric", month: "long", year: "numeric" }).format(new Date(d));

export async function syncSubscriptionFromFirestore(uid) {
  const cache = accountStorage();
  if (!uid || cache.uid !== uid) return null;
  try {
    const snap = await getDoc(doc(db, "users", uid, "account", "subscription"));
    if (snap.exists()) {
      const data = snap.data();
      const sub = {
        accountType: data.accountType ?? (data.status === "pilot" ? "pilot" : "real"),
        status: data.status || "none",
        plan: data.plan ?? null,
        currentPeriodEnd: data.currentPeriodEnd?.toDate
          ? data.currentPeriodEnd.toDate().toISOString()
          : data.currentPeriodEnd ?? null,
        trialEndsAt: data.trialEndsAt?.toDate
          ? data.trialEndsAt.toDate().toISOString()
          : data.trialEndsAt ?? null,
        methodMask: data.methodMask ?? null,
        provider: data.provider ?? null,
      };
      if (!cache.isCurrent()) return null;
      cache.write(KEY, sub);
      return sub;
    }
    cache.write(KEY, PRESETS.none());
  } catch {
    // offline or fallback
  }
  return null;
}

